<template>
    <div class="tabRight">
        <div class="tab3">
            <ul>
                <li v-on:click="all(col_ids)"><span :class="{active: isActive == ''}">全部</span></li>
                <li v-for="(item,index) in sub" :key="index">
                    <span v-if="typeof item.str == 'string'" :class="{ active: isActive == item.str }"><a :href="item.str" target="_blank">{{item.name}}</a></span>
                    <span v-else :class="{ active: isActive == item.str }" v-on:click="subtab(item.str)">{{item.name}}</span>
                </li>
            </ul>
        </div>
       <ul class="content">
           <li v-for="(item,index) in artical" :key="index">
               <a v-if="item.ShowType == 2" :href="'http://lishui.yeshiweb.com:8081/web//Detail/VideoDetail?col_id='+item.ColId+'&art_id='+item.Id">
                    <img v-if="item.Ico1" :src="'http://lishui.yeshiweb.com:8081/'+item.Ico1">
                    <h3>{{item.ArtTitle}}</h3>
                    <!-- <p class="type_">{{item.Created}}<span>{{item.ClickNum}}人浏览过</span></p> -->
               </a>
               <a v-else-if="item.ShowType == 5" :href="item.OutLink">
                    <img v-if="item.Ico1" :src="'http://lishui.yeshiweb.com:8081/'+item.Ico1">
                    <h3>{{item.ArtTitle}}</h3>
                    <!-- <p class="type_">{{item.Created}}<span>{{item.ClickNum}}人浏览过</span></p> -->
               </a>
                <router-link v-else :to="{ path: '/artical',query:{colid:item.Id}}">
                    <img v-if="item.Ico1" :src="'http://lishui.yeshiweb.com:8081/'+item.Ico1">
                    <h3>{{item.ArtTitle}}</h3>
                    <!-- <p class="type_">{{item.Created}}<span>{{item.ClickNum}}人浏览过</span></p> -->
               </router-link>
           </li>
       </ul>
    </div>
</template>

<script>
import api from '../assets/config/api'
import axios from 'axios'
export default {
data() {
    return {
        artical:[],
        isActive:''
    };
},
props:['col_ids','sub'],
watch: {
    '$route' (to, from) {
        this.$router.go(0);
    }
},
methods: {
    subtab: function (str) {
        // console.log(str)
        //从art里获取数据设置artical
            var colids = str;
            axios.post(api.atrDetail, {
                col_ids:colids
            })
            .then(response => {
                // console.log(response.data.Items);
                this.artical = response.data.Items;
                this.isActive = str
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    all:function(value){
        axios.post(api.atrDetail, {
            col_ids:value,page_index:1
        })
        .then(response => {
            // console.log(response.data.Items);
            this.artical = response.data.Items;
            this.isActive = ''
        })
        .catch(function (error) {
            console.log(error);
        });
    }
},
async mounted() {
    var colids = this.col_ids
    await axios.post(api.atrDetail, {
        col_ids:colids,page_index:1
    })
    .then(response => {
        // console.log(response.data.Items);
        this.artical = response.data.Items;
    })
    .catch(function (error) {
        console.log(error);
    });
},

}
</script>
<style lang="less" scoped>
.tabRight{
    padding-left: 80px;
    .tab3{
        ul{
            overflow: hidden;
            li{
                float: left;
                line-height: 45px;
                cursor: pointer;
                span{
                    font-size: 22px;
                    padding: 0 10px;
                    color: #666;
                    a{
                        color: #666;
                    }
                }
                :hover{
                    color: #f39389;
                }
            }
        }
        .active{
            color: #f39389;
        }
    }
    .content{
        li{
            overflow: hidden;
            padding: 25px 0;
            border-bottom: 1px solid #ddd;
            position: relative;
            min-height: 130px;
            h3{
                font-size: 24px;
                line-height: 32px;
                height: 64px;
                overflow: hidden;
                font-weight: normal;
                &:hover{
                    color: #e82a14;
                }
            }
            img{
                width: 190px;
                height: 130px;
                float: left;
                margin-right: 25px;
                border-radius: 10px;
            }
            p{
                line-height: 38px;
                font-size: 24px;
                color: #999;
                padding-top: 38px;
                span{
                    float: right;
                }
            }
        }
    }
}
</style>